import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';
import {HeaderService} from '../../header.service';

@Component({
    selector: 'app-quality',
    templateUrl: './quality.component.html',
    styleUrls: ['./quality.component.css']
    })
export class QualityComponent implements AfterViewInit {

    @ViewChild('qualityVideo') qualityVideo?: ElementRef<HTMLVideoElement>;

    constructor(private headerService: HeaderService) {
        this.headerService.setHeaderTitle('Qualität');
        this.headerService.setHeaderImage('assets/img/quality/background.jpg');
        this.headerService.setHeaderContext('Als zertifizierter Mitgliedsbetrieb der Genussregion Pongauer' +
            ' Wild gibt es bei uns perfektes Wildbret in höchster Qualität. Dazu kommt eine Vielfalt an' +
            ' Wildwurstspezialitäten aus hauseigener Produktion – an der Theke gibt es gerne Auskunft dazu.');
    }

    ngAfterViewInit(): void {
        this.silence(this.qualityVideo?.nativeElement);
    }

    muteVideo(event: Event): void {
        this.silence(event.target as HTMLVideoElement);
    }

    private silence(video?: HTMLVideoElement): void {
        if (!video) {
            return;
        }

        video.muted = true;
        video.defaultMuted = true;
        video.volume = 0;
    }
}
